const GuidRegex = /[xy]/g;

export function newGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 3) | 8;
        return v.toString(16);
    });
}
